export default __webpack_public_path__ + "static/media/scheduler-demo.ac948923.gif";